import { Fragment } from 'react';
import ActionBtn from '../../components/Button/ActionBtn';
import Layout from '../../components/Layout/Layout'
import { StaggerTestimonials } from './Testimonials';

import CollapseCardFeatures from './SubHeroModule';
import CardEndOffer from '../../components/CardEndOffer';

import { Col, Container, Row } from 'react-bootstrap'

import { CountUpStats } from './CountUpStats';
import StackedCardTestimonials from './StackedCards';

const FuteurCred = () => {
   
    return (
        <Fragment>
            <Layout title='Futeur Cred' description='Futeur Cred Desc' >
                <section className='pt-[50px] md:pt-[80px] pb-0 relative overflow-hidden'>
                    <img src={"/images/Container.svg"} className='absolute w-full h-full object-cover left-1/2 -translate-x-1/2 top-0 pointer-events-none' alt="" />
                    <Container className='relative z-[1] mt-[3rem]'>
                  
                    <h2 className="font-bold text-2xl md:text-6xl mb-4 sm:mb-[3rem] lg:mb-[5rem] text-center text-black">
                    Navigate Business Credit.
                  </h2>
                  <h3 className="font-bold text-2xl md:text-6xl mb-4 sm:mb-[3rem] lg:mb-[5rem] text-center text-black pb-6">Introducing FuteurCred.</h3>
                  <h3 className="font-medium text__32 mb-6 sm:mb-[3rem] lg:mb-[5rem] text-center text-black">
                  Crafted exclusively for businesses, powered by insights from 2 million Small Business Owners across America, FuteurCred turns complexity into clarity—enabling smarter decisions, faster growth, and actionable credit strategies.
                  </h3>
                  <div className="relative mx-auto w-full max-w-[800px] h-auto">
                  <video
                    src="/FuteurCred.mp4"
                    className="mx-auto w-full max-h-[400px] rounded-[32px] object-cover"
                    loop
                    autoPlay
                    muted
                    playsInline
                    alt="Video preview"
                  />
                  <img
                    src="/mockups/FuteurCred.png"
                    className="absolute inset-0 mx-auto w-full max-h-[400px] rounded-[32px] object-cover hidden"
                    alt="Fallback preview"
                  />
                </div>
                    </Container>
                </section>
                <section className='py-20 text-black'>

              <StackedCardTestimonials />
            
            </section>
               
            <section className='py-2 bg-white'>

            <div className="px-2">
                <div className="w-full lg:px-4 xl:px-[2.5rem] py-[2rem] lg:py-[4rem] bg-black rounded-[34px] sm:rounded-[56px]">
                    <Container>

                        <Row className='justify-between mb-[3rem]'>
                            <Col md={6} className='lg:my-auto'>

                            <div className="text-center">
                            <h4 className="h1 font-bold text-white">
                              Solution <br /> FuteurAI <br />
                            </h4>
                            <h3 className="text__36 text-white mb-[2.5rem]">
                              The Credit Karma for Business
                            </h3>
                          </div>

                            </Col>
                            <Col md={5} className='lg:my-auto'>
                                <p className='text__18 text-white leading-relaxed md:mb-[2.5rem] text-center'>FuteurAI isn’t just another app—it’s the ultimate companion for your business.</p>
                                <div className="flex justify-center items-center h-full mb-10">
                                <ActionBtn
                                  link="https://app.futeur.ai/signup"
                                  title="Experience Now"
                                  variant={3} // Orange button variant
                                  size="normal"
                                />
                              </div>
                            </Col>
                        </Row>

                        <Row className='h-full gap-y-4'>
                            <Col md={5} className='flex-fill'>
                                <div className="grid grid-rows-2 gap-y-4 md:gap-y-8 h-full">
                                    <div className="w-full flex items-center justify-center p-4 rounded-[32px] bg-Msecondary600">
                                        <div className="">
                                        <h5 className='font-medium text__36 mb-8 text-white'>The Smarter, Faster Credit Solution for Business Success</h5>

                                            <p className='text__18 leading-relaxed text-white mb-8'>FuteurAI is not just another credit monitoring platform. We are the only service outside the bureaus offering full PDF credit reports combined with real-time monitoring and actionable insights tailored specifically for businesses.
                                            </p>
                                            <div className="flex space-x-4">
                                            <ActionBtn type={2} title="See How It Works" link='/SeeHowItWorks'/>
                                            <ActionBtn type={2} title="See Samples" link='/SeeSample'/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex items-end justify-center p-4 rounded-[32px] bg-white">
                                        <div className="">
                                            <h5 className='font-medium text__36 mb-8 text-Mneutral900'>What Makes FuteurAI Essential?</h5>
                                            <p className='text__18 leading-relaxed text-Mneutral600'>Discover how FuteurAI simplifies your business credit journey. Navigate an intuitive platform, access full, unaltered PDF credit reports straight from the bureaus, and gain the advantage of real-time monitoring with actionable alerts. Stay ahead of every opportunity and challenge with a tool built to empower your business.</p>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col md={7} className='flex-fill'>
                                <img src={"/mockups/FuteurCred(2).png"} className='object-cover w-full rounded-[32px] h-full' alt="" />
                            </Col>
                        </Row>

                    </Container>
                </div>
            </div>
        
        </section>
        <section className='py-2 text-black rounded-[42px]'>
        <CollapseCardFeatures />
        </section>
                <section className='py-2'>
                 
                    <div className="xs:px-2">
                        <div className="w-full lg:px-4 xl:px-[2.5rem] py-[2rem] lg:py-[4rem] bg-Mneutral100 rounded-[24px] sm:rounded-[56px]">
                            <Container>
                           
                                <div className="grid grid-rows-1 gap-y-6">

                                    <div className="w-full p-3 bg-white rounded-[32px]">
                                        <Row className='justify-between gap-y-3'>
                                            <Col md={7} className='my-auto md:!order-1 order-2'>
                                                <div className="lg:px-[4rem]">
                                                    <h4 className='font-medium text__48 mb-10 text-black'>Rebuilding Your Trust and Security                                                   </h4>
                                                    <p className='text__18 leading-relaxed mb-[1rem] text-black font-bold'>Advanced Data Protection
                                                    </p>
 
                                                     <p className='text__18 leading-relaxed mb-[3rem] text-black' >Your data is safeguarded with enterprise-grade encryption and multi-layered security protocols, addressing vulnerabilities exposed by recent breaches and ensuring your information remains private and secure.</p>
                                                     <p className='text__18 leading-relaxed mb-[1rem] text-black font-bold'>Team-Wide NIST CSF Certification
                                                     </p>
  
                                                     <p className='text__18 leading-relaxed mb-[3rem] text-black' >Every FuteurAI team member is individually certified as NIST CSF compliant, underscoring our commitment to safeguarding your business against risks like the recent Krispy Kreme breach and reinforcing the highest standards of data privacy.</p>
                                                  
                                                </div>
                                            </Col>
                                            <Col md={5} className='my-auto order-1 md:!order-2'>
                                                <img src={"/security.png"} alt="" />
                                            </Col>
                                        </Row>
                                    </div>
                                    {/*
                                    <div className="w-full p-3 bg-white rounded-[32px]">
                                        <Row className='justify-between gap-y-3'>
                                            <Col md={5} className='my-auto'>
                                                <img src={"/images/gfbgfh (2).svg"} alt="" />
                                            </Col>
                                            <Col md={7} className='my-auto'>
                                                <div className="lg:px-[4rem]">
                                                    <h4 className='font-medium text__48 mb-2 text-black'>Time-Saving Efficiency</h4>
                                                    <p className='text__18 leading-relaxed mb-[3rem] text-black'>Benefit from automated tracking and real-time updates, allowing you to stay informed and make quick, effective financial decisions without the manual effort.</p>

                                                    <ActionBtn link='/about' title="Get Started" />
                                                </div>
                                                
                                            </Col>
                                        </Row>
                                    </div>
                                    */}
                                    <div className="w-full p-3 bg-white rounded-[32px] text-black">
                               
                                    <CountUpStats />
                                    </div>
                                </div>

                            </Container>
                        </div>
                    </div>

                </section>
         
                <StaggerTestimonials />
                
                 <section className='py-12 sm:py-16 bg-white'>
                          <Container className='px-4 sm:px-6 lg:px-8'>
                            <div className="w-full bg-Mneutral100 rounded-[24px] sm:rounded-[56px] p-6 sm:p-8 lg:p-12">
                              <Row className='gap-y-4'>
                                <Col md={6} className='my-auto'>
                                  <img 
                                    src={"/FuteurLogo.png"}
                                    alt="Futeur Logo"
                                    className='max-w-[300px] sm:max-w-[400px] md:max-w-none'
                                  />
                                </Col>
                                <Col md={6} className='my-auto'>
                                <h4 className='font-bold text-black text-center text-3xl sm:text-4xl md:text-4xl mb-20'> Secure Your Spot in America’s Small Business Revolution</h4>
                                  <h4 className='font-medium text-black text-center text-3xl sm:text-4xl md:text-3xl mb-3'>
                                  Join 34.8 M businesses already transforming their futures with FuteurCred. Together, we rebuild America’s economy
                                  </h4>
                                 
                                 <div className="flex justify-center mt-5"> <ActionBtn
                                           link="https://app.futeur.ai/signup"
                                           title="Get Started Today"
                                           variant={3} // Secondary button style
                                           size="normal"
                                         /></div>
                                </Col>
                              </Row>
                            </div>
                          </Container>
                        </section>
                             
            </Layout>
        </Fragment>
        
    )
    
}

export default FuteurCred

